import { Link, useLocation } from "react-router-dom";
import { CHAPTERS } from "../lib/data";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function ChapterNav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating gentle chapter button */}
      <button
        data-testid="open-chapter-menu"
        onClick={() => setOpen(true)}
        className="fixed top-6 right-6 z-50 flex items-center gap-2 px-4 py-2 rounded-full bg-[#D6BFA0]/90 backdrop-blur-md border border-[#A87149] shadow-sm hover:shadow-md transition-all duration-700 hover:-translate-y-[1px]"
        aria-label="Open chapters"
      >
        <Menu size={16} className="text-[#4B3A2F]" />
        <span className="font-display text-base tracking-wide text-[#4B3A2F]">
          Chapters
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[60] bg-[#2C2724]/45 backdrop-blur-sm overflow-y-auto"
          onClick={() => setOpen(false)}
          data-testid="chapter-menu-overlay"
        >
          <div className="min-h-full flex items-center justify-center px-6 py-10">
            <div
              className="parchment-deep page-shadow max-w-lg w-full rounded-md border border-[#A87149] p-10 relative"
              onClick={(e) => e.stopPropagation()}
            >
            <button
              data-testid="close-chapter-menu"
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 text-[#6D5A50] hover:text-[#2C2724] transition-colors"
              aria-label="Close"
            >
              <X size={20} />
            </button>
            <p className="font-script text-3xl text-[#4B3A2F] text-center">
              Choose a chapter
            </p>
            <div className="gold-rule my-5" />
            <ul className="space-y-1">
              {CHAPTERS.map((c) => {
                const active = pathname === c.path;
                return (
                  <li key={c.path}>
                    <Link
                      data-testid={`nav-link-${c.path.replace(/\//g, "") || "home"}`}
                      to={c.path}
                      onClick={() => setOpen(false)}
                      className={`flex items-baseline justify-between px-3 py-3 border-b border-[#A87149]/70 transition-colors duration-500 ${
                        active
                          ? "text-[#4B3A2F]"
                          : "text-[#2C2724] hover:text-[#4B3A2F]"
                      }`}
                    >
                      <span className="flex items-baseline gap-4">
                        <span className="font-display italic text-[#D62839] text-lg w-8">
                          {c.short}
                        </span>
                        <span className="font-display text-2xl">
                          {c.label}
                        </span>
                      </span>
                      {active && (
                        <span className="font-script text-xl text-[#4B3A2F]">
                          you are here
                        </span>
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <p className="mt-8 text-center text-sm text-[#6D5A50] italic">
              Where Faith Finds Its Salt.
            </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
